








import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import ReceiptGenerator from '@/components/ReceiptGenerator/index';
import type { ReceiptData } from './types';

@Component({
  components: {
    ReceiptGenerator,
  },
})
export default class extends Vue {
  @Prop({ default: false })
  show!: boolean;
  @Prop({ default: () => ({}) })
  data!: ReceiptData

  get visible() {
    return this.show
  }

  set visible(val: boolean) {
    this.$emit('update:show', val)
  }
}
